import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-734b08c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "anmeldereport" }
const _hoisted_2 = { class: "contentHeader flex relative" }
const _hoisted_3 = { class: "relative ml-2" }
const _hoisted_4 = { class: "absolute" }
const _hoisted_5 = { class: "contentBox flex-col" }
const _hoisted_6 = { class: "block w-full" }
const _hoisted_7 = { class: "flex mb-4" }
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-anmelden" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "text-center" }

import {onBeforeUnmount, onMounted, reactive, ref} from 'vue';
import { BryntumGrid } from "@bryntum/grid-vue-3";
import {Store, StringHelper} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import { useGlobalStore } from "@/stores/GlobalStore";
import isNullOrUndefined from "@/utilities/helpers/NullOrUndefinedHelper";
import {DisdiStateType, ErrorLocationType, PopupType, TableType} from '@/utilities/enums/Enums';
import Error from "@/components/Error";
import {useI18n} from "vue-i18n";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {$t} from "@/utilities/i18n/config";
import {defaultSpaceAroundTableOnPage, permissionColumn} from "@/AppConfig";
import dialog from "@/dialog";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";
import FilterService from "@/utilities/services/FilterService";
import Autorefresh from "@/components/Autorefresh.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {PermissionService} from "@/utilities/services/PermissionService";
import {GroupedSystemSettings} from "@/models/setting/GroupedSystemSettings";
import {RegisteredUserInfo} from "@/models/registration/RegisteredUserInfo";
import {RegistrationService} from "@/utilities/services/entities/RegistrationService";
import {SettingService} from "@/utilities/services/entities/SettingService";
import {SystemSetting} from "@/models/setting/SystemSetting";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import router from "@/router";
import { Guid } from "guid-typescript";
import { ClientIconHelper } from '@/utilities/helpers/ClientIconHelper';



export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationReports',
  setup(__props) {

const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();
const registrationService = new RegistrationService();
const permissionService = new PermissionService();
const settingService = new SettingService();

const currentWindowHeight = ref("");
const recalcGridHeight = () => {
  currentWindowHeight.value = `${window.innerHeight-defaultSpaceAroundTableOnPage}px`;
};

const toggleAutoRefresh = () => {
  globalStore.refreshIsActive = !globalStore.refreshIsActive;
}

const openRegisterPopup = () => {
  globalStore.openPopup({
    data: {},
    action: setGridData,
    resetButton: false,
    title: $t("locationsReports.registerPopup"),
    type: PopupType.registerPopup
  });
}

const grid = ref(null);
const useGridConfig = {
  relayStoreEvents: true,
  height: currentWindowHeight,
  headerMenuFeature: false,
  enableTextSelection: true,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  columns : {
      data: [
      
      {
        id:'isActive',
        field: 'isActive',
        text: "",
        width: 30,
        minWidth: 30,
        type: "template",
        template: ({ record }) => {
          return record.data.isActive
              ? `<div class="userActivity isActive"</div>`
              : `<div class="userActivity"></div>`;
        },
      },
      { id:'kid', field: 'kid', text: t('registrationReports.grid.kid'), flex: 1},
      { id:'lastName', field: 'lastName', text: t('registrationReports.grid.lastName'), flex: 1},
      { id:'firstName', field: 'firstName', text: t('registrationReports.grid.firstName'), flex: 1},
      {
        id: 'infoButton',
        field: 'infoButton',
        text: t('registrationReports.grid.info'),
        width: 70,
        sortable: false,
        minWidth: 70,
        type: "template",
        template: () => {
          return `<div class='gridRowButton'><span class='icon-info'></span></div>`;
        },
      },
      {
        id:'companyName',
        field: "companyName",
        text: t("popups.registrationReports.grid.company"),
        flex:1,
        type: "template",
        template: ({record}:any)=>{
          if(isNullOrUndefined(record.data.companyName)) record.data.companyName = globalStore.settings.systemCompanySettings?.companyName;
					return StringHelper.xss`${record.data.companyName ?? ""}`;
        },
      },
      {
        id:'lastLocationName',
        field: 'lastLocationName',
        text: t('registrationReports.grid.location'),
        flex: 1
      },
          {
              id: 'lastRegisteredLocationDate',
              field: 'lastRegisteredLocationDate',
              text: t('registrationReports.grid.register'),
              flex: 1,
              sortable: true,
              type: 'template',
              template: ({ record }: any) => {
                  if (NullOrUndefinedHelper(record.data.lastRegisteredLocationDate)) {
                      return '';
                  }

                  const icon = ClientIconHelper.getIcon(record.data.registeredLocationInfo[0].client);
                  const tooltip = (record.data.registeredLocationInfo[0].client);

                  if (record.data.registeredLocationInfo[0].hideDates) {
                      return `<span title="${tooltip}">${icon}</span>`;
                  }

                  const reg = DateToStringHelper(
                      new Date(record.data.lastRegisteredLocationDate)
                  );

                  return `${reg} <span title="${tooltip}">${icon}</span> `;

              }
          },
          {
              id: 'lastUnRegisteredLocationDate',
              field: 'lastUnRegisteredLocationDate',
              text: t('registrationReports.grid.unregister'),
              flex: 1,
              sortable: true,
              type: 'template',
              template: ({ record }: any) => {
                  if (NullOrUndefinedHelper(record.data.lastUnRegisteredLocationDate)) {
                      return '';
                  }

                  const icon = ClientIconHelper.getIcon(
                      record.data.registeredLocationInfo[0].unregistrationClient,
                      record.data.registeredLocationInfo[0].unRegistrationReason
                  );
                  const tooltip = (record.data.registeredLocationInfo[0].unregistrationClient);

                  if (record.data.registeredLocationInfo[0].hideDates) {
                      return `<span title="${tooltip}">${icon}</span>`;
                  }

                  const unreg = DateToStringHelper(
                      new Date(record.data.lastUnRegisteredLocationDate)
                  );

                  return `${unreg} <span title="${tooltip}">${icon}</span> `;

              }
          },
      { id:'lastGuestCount', field: 'lastGuestCount',
        text: t('registrationReports.grid.guestCount'),
        width: 100,
      },
      { id:'email', field: 'email', text: t('registrationReports.grid.email'), flex: 1 },
      { id:'phoneNumber', field: 'phoneNumber', text: t('registrationReports.grid.phoneNumber'), flex: 1 },
      {
        id:'activityText',
        field: 'activityText',
        sortable: false,
        hidden: !globalStore.settings.activitySettings?.activitesEnabled,
        text: '',
        width   : 36,
        type: "template",
        tooltipRenderer : ({ record }) =>{
          return isNullOrUndefined(record.activityText)
              ? ""
              : StringHelper.xss`<b>${t('registrationReports.grid.activity')}</b><br/>${record.activityText ?? ""}<br/>`;
        },
        template: ({record}) => {
          return isNullOrUndefined(record.activityText)
              ? ""
              : record.activityText === defaultActivityText.value && globalStore.settings.activitySettings?.defaultActivitExchangeable
                  ? `<div class='gridRowButton'><span class='icon-activity'></span></div>`
                  : `<div class='gridTooltipButton'><span class='icon-activity'></span></div>`;
        },
      },
      {
        id:'disdi',
        text	: "",
        width   : 36,
        type	: 'template',
        align: "center",
        hidden: !permissionService.userHasPermission("Disdi.Read"),
        resizable: false,
        filterable: false,
        template : ({record}:any)=>{
          const currentRegLocation = record.data.registeredLocationInfo[0];
          return  currentRegLocation.hasDisdi && record.data.disdiCount > 0
              ? `<div class='gridRowButton'><span class='icon-liste_tagebuch'></span></div>`
              :  currentRegLocation.hasDisdi && record.data.disdiCount === 0
                  ? `<div class='gridRowButtonDisabled'><span class='icon-liste_tagebuch'></span></div>`
                  : "";
        }
      },
      {
        id:'unregister',
        field: 'unregister',
        text: '',
        sortable: false,
        width   : 36,
        type: "template",
        template: ({record}) => {
          if(permissionService.userHasPermission("RegistrationReport.User.Logout")) {
            return record.data.isActive ? `<div class='gridRowButton'><span class='icon-abmelden'></span></div>` : "";
          } else {
            return "";
          }
        },
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.register], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  listeners: {
    datachange(){
      globalStore.currentItems = gridStore.count;
      globalStore.allItems = gridStore.originalCount;
    },
    async cellClick({column, record}) {
      if (column.data.field === 'infoButton' ) {
        if(permissionService.userHasPermission("RegistrationReport.Read")) {
          globalStore.openPopup({
            data: record.data,
            action: globalStore.closeModal,
            title: t('registrationReports.userHistoryPopup'),
            type: PopupType.registrationUserHistory
          }, true);
        }
        return;
      }

      if (column.data.field === 'unregister') {
        const openReg = record.data.registeredLocationInfo.find((opr:any) => opr.lastUnRegisteredLocationDate === null);
        const answer = await dialog
            .okText(t("global.unregister"))
            .cancelText(t("global.cancel"))
            .confirm(t("registrationReports.confirmUnregister", { name:record.data.fullName, location:openReg.locationName}));

        if (answer){
          const unregResp = await registrationService.postUnRegisterUser(record.data.id, openReg.locationId);
          if(unregResp === null || unregResp === undefined || unregResp?.statusCode !== 0){
            ErrorHandler.handleError(unregResp, ErrorLocationType.table);
            return;
          }

          globalStore.showSuccess(t('popups.register.unregistered'));
        }
      }

      if (column.data.field === 'activityText' && !isNullOrUndefined(record.data.activityText)){
        if(record.data.activityText === defaultActivityText.value && globalStore.settings.activitySettings?.defaultActivitExchangeable){
          globalStore.openPopup({
            data: record.data,
            action: changeActivityForRegistration,
            resetButton: false,
            title:$t("popups.registrationReports.changeActivity.title"),
            type:PopupType.changeActivityForRegistration
          })
        }
      }

      if(column.data.id === 'disdi'){
          
          const rd = record.data;
          const currentRegLocation = rd.registeredLocationInfo[0];
          
          if (!currentRegLocation.hasDisdi || rd.disdiCount === 0) return;
          
          globalStore.setDisdiContext({...rd,
            registrationId: currentRegLocation.registrationId,
            lastRegisteredLocationDate: currentRegLocation.lastRegisteredLocationDate,
            locationName: currentRegLocation.locationName}
        );
        await router.push(`disdi/${TableType[TableType.register]}/${+rd.registrationId}`);
      }
    },
  },
}
const gridConfig = reactive(useGridConfig);

const defaultActivityText = ref("");
const getDefaultActivityText = async ()=>{
  const defaultActivityResp = await settingService.getSystemSettings();
  // silent fail :(
  if (defaultActivityResp === null || defaultActivityResp === undefined || defaultActivityResp.statusCode !== 0) return;

  return defaultActivityResp.settingInfo
      //@ts-expect-error
      .find((ss:GroupedSystemSettings) => ss.name === "Tätigkeiten")?.children
      .find((s:SystemSetting) => s.name === "Tätigkeitsgruppen:  Unbestimmte Tätigkeit")
      .value;
}

const reapplyFilterAndHiddenCols = async ()=>{
  // apply filters
  gridStore.filter({
    id: "userFilter",
    filterBy: FilterService.buildFilter(TableType[TableType.register])
  });

  // apply hidden cols
  for(const c of grid.value.instance.value.columns.storage.values){
    const needsHiding = globalStore.userPreferences.userHiddenColumns.some((thc) => thc.attributeName === c.data.field && thc.tableName === TableType[TableType.register]);

    if(needsHiding && !c.hidden) {
      c.hide();
    }
    else if(!needsHiding && c.hidden && !permissionColumn.includes(c.id)) {
      c.show();
    }
  }

  globalStore.reorderColumns(TableType[TableType.register]);
}

const changeActivityForRegistration = async()=>{
  const registration = globalStore.modal.contentObject as RegisteredUserInfo;

  //check if it is still default activity, if so dont update and leave popup open
  if(registration.activityText === defaultActivityText.value) return;

  // update corresponding open reg in registeredLocationInfo list
  // @ts-expect-error
  registration.registeredLocationInfo[0].activityText = registration.activityText;

  const changeResp = await registrationService.postChangeActivityForRegistration(registration.registeredLocationInfo[0].registrationId, registration.activityId, registration.activityText);
  if (changeResp === null || changeResp === undefined || changeResp.statusCode !== 0) {
    ErrorHandler.handleError(changeResp, ErrorLocationType.popup);
    return;
  }

  gridStore.add(registration);

  await reapplyFilterAndHiddenCols();

  globalStore.closeModal();
  globalStore.showSuccess(t('global.saved'));
}

const setGridData = async ()=> {
  const regReportsResp = await registrationService.getRegistrationReports();
  if (regReportsResp === null || regReportsResp === undefined || regReportsResp.statusCode !== 0) {
    ErrorHandler.handleError(regReportsResp, ErrorLocationType.table);
    return;
  }

  //convert data to specific properties to make grid able to sort the data
  const convertedData = regReportsResp.registrationInfo.map(r => {
    r.lastRegisteredLocationDate = r.registeredLocationInfo[0].lastRegisteredLocationDate;
    r.lastUnRegisteredLocationDate = r.registeredLocationInfo[0].lastUnRegisteredLocationDate;

    if(NullOrUndefinedHelper(r.id)) r.id = Guid.create();

    return r
  })

  gridStore.setStoreData(convertedData);
  
   // Apply an initial sort to display assets first
   gridStore.sort('isActive', false); // false -> Sort descending (1 first, 0 next)

  await reapplyFilterAndHiddenCols();

  globalStore.reorderColumns(TableType[TableType.register]);

  globalStore.closeModal();
};

const setDisdiColumVisibility = async() =>{
  const disdiIsOn = globalStore.settings.disdiSettings?.disdi !== DisdiStateType.NoDISDI;

  if(!disdiIsOn){
    const hasDisdiCol = grid.value.instance.value.columns.getById("disdi");
    hasDisdiCol.hidden = true;
  }
}

onMounted(async ()=>{
  // calculate grid height and sub to window resize event
  recalcGridHeight();
  window.addEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  defaultActivityText.value = await getDefaultActivityText();

  // start spinner
  globalStore.gridDataIsLoading = true;

  await setGridData();
  await setDisdiColumVisibility();

  // stop spinner
  globalStore.gridDataIsLoading = false;
});

onBeforeUnmount(()=>{
  window.removeEventListener('resize', recalcGridHeight);

  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)("registrationReports.title")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Autorefresh, { onClick: toggleAutoRefresh })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_unref(Error), {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              onClick: openRegisterPopup,
              title: _unref(t)('locationsReports.newLocationReport')
            }, _hoisted_10, 8, _hoisted_8)), [
              [_directive_permission, 'Registration.Manual']
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(GridInputFilter), {
                gridStore: _unref(gridStore),
                popupType: _unref(PopupType).registrationFilterPopup,
                hideFilterButton: false
              }, null, 8, ["gridStore", "popupType"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(globalStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(globalStore).gridDataIsLoading]
      ])
    ])
  ]))
}
}

})